var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 40,
    viewBox: "0 0 61 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_25025)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.4999,
    cy: 29.5405,
    r: 29.7143,
    fill: "url(#paint0_linear_8_25025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0713 31.5405C15.0713 22.8617 22.1068 15.8262 30.7856 15.8262C39.4643 15.8262 46.4999 22.8617 46.4999 31.5405V42.6833H15.0713V31.5405Z",
    fill: "url(#paint1_linear_8_25025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92878 32.1136C7.92878 19.4899 18.1623 9.25642 30.7859 9.25642C43.4096 9.25642 53.6431 19.4899 53.6431 32.1136V48.1136H7.92878V32.1136Z",
    stroke: "#FFF5F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.571429
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_25025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3127 36.1172C37.9429 36.1172 37.6431 36.417 37.6431 36.7868V41.0279H38.9824V36.7868C38.9824 36.417 38.6825 36.1172 38.3127 36.1172Z",
    fill: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0181 41.0279V36.7868C22.0181 36.417 22.3179 36.1172 22.6877 36.1172C23.0575 36.1172 23.3574 36.417 23.3574 36.7868V41.0279",
    fill: "#BC435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9664 29.9386C33.7745 29.9386 31.9912 28.1553 31.9912 25.9634C31.9912 23.7715 33.7745 21.9883 35.9664 21.9883C38.1583 21.9883 39.9415 23.7715 39.9415 25.9634C39.9415 28.1553 38.1583 29.9386 35.9664 29.9386Z",
    fill: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.283 29.442C23.5021 29.442 22.0532 27.9932 22.0532 26.2122C22.0532 24.4313 23.5021 22.9824 25.283 22.9824C27.064 22.9824 28.5128 24.4313 28.5128 26.2122C28.5128 27.9932 27.064 29.442 25.283 29.442Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4556 29.5402C29.2594 30.434 30.4995 32.2938 30.4995 34.4434L29.6067 41.0282H40.7674C41.1372 41.0282 41.437 40.7284 41.437 40.3585V34.4434C41.437 32.5459 40.4707 30.8742 39.0033 29.8934C38.1628 30.5448 37.1084 30.933 35.9651 30.933C34.356 30.933 32.9231 30.1642 32.0144 28.9746H27.9917C27.833 29.1813 27.6532 29.3709 27.4556 29.5402Z",
    fill: "url(#paint2_linear_8_25025)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5978 29.543C23.2871 30.0276 24.1265 30.3123 25.0312 30.3123C25.936 30.3123 26.7754 30.0276 27.4647 29.543C29.2639 30.4384 30.5 32.2957 30.5 34.4418V41.0266H20.2321C19.8623 41.0266 19.5625 40.7268 19.5625 40.357V34.4418C19.5625 32.2957 20.7986 30.4384 22.5978 29.543Z",
    fill: "url(#paint3_linear_8_25025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5806 32.2098C38.5806 31.1636 39.4317 30.3125 40.4779 30.3125C41.2779 30.3125 41.9288 30.9634 41.9288 31.7634V33.4375C41.9288 33.8073 41.629 34.1071 41.2591 34.1071H40.4779C39.4317 34.1071 38.5806 33.256 38.5806 32.2098Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5227 34.1071H19.7414C19.3716 34.1071 19.0718 33.8073 19.0718 33.4375V31.7634C19.0718 30.9634 19.7227 30.3125 20.5227 30.3125C21.5689 30.3125 22.42 31.1636 22.42 32.2098C22.42 33.256 21.5689 34.1071 20.5227 34.1071Z",
    fill: "#D6A2BE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.2141,
    cy: 17.5413,
    rx: 1.14286,
    ry: 1.14286,
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2141,
    cy: 18.6839,
    rx: 1.14286,
    ry: 1.14286,
    fill: "#D6A2BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_25025",
    x1: 30.4999,
    y1: -0.173828,
    x2: 30.4999,
    y2: 53.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_25025",
    x1: 30.7856,
    y1: 15.8262,
    x2: 30.7856,
    y2: 42.6833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_25025",
    x1: 33.234,
    y1: 28.9746,
    x2: 33.234,
    y2: 41.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_25025",
    x1: 25.0312,
    y1: 29.543,
    x2: 25.0312,
    y2: 41.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67D95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_25025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4286,
    height: 40,
    fill: "white",
    transform: "translate(0.785645)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_25025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8571,
    height: 22.8571,
    fill: "white",
    transform: "translate(19.0713 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCricle);
export default __webpack_public_path__ + "static/media/create-cricle.fb05a49b199fb46a188f64395acdb8b1.svg";
export { ForwardRef as ReactComponent };